export enum HttpStatusCodes {
  INTERNAL_SERVER_ERROR = 500,
}
